import { createFileRoute } from '@tanstack/react-router';
import { StudySessions } from '@/components/Modules/StudySessions';

export const Route = createFileRoute('/sessions')({
  component: StudySessions,
});
